export default "__VITE_ASSET__tXCWpdzy__"